(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["centre-order-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('.cob');
  if (!section) return;

  /* ── PRODUCT CATALOGUE — built from theme editor settings ── */
  var d = section.dataset;
  var PRODS = {
    baby: {
      allseasons: {
        id: parseInt(d.vidBabyAllPack) || 0, size: 3, price: 0,
        name: d.nameBabyAllPack || '', img: d.imgBabyAll || '', url: d.urlBabyAll || '',
        carton: {
          id: parseInt(d.vidBabyAllCarton) || 0, size: 48, price: 0,
          name: d.nameBabyAllCarton || '', img: d.imgBabyAllCarton || ''
        }
      },
      christmas: {
        id: parseInt(d.vidBabyXmasPack) || 0, size: 4, price: 0,
        name: d.nameBabyXmasPack || '', img: d.imgBabyXmas || '', url: d.urlBabyXmas || '',
        carton: {
          id: parseInt(d.vidBabyXmasCarton) || 0, size: 24, price: 0,
          name: d.nameBabyXmasCarton || '', img: d.imgBabyXmasCarton || ''
        }
      }
    },
    junior: {
      allseasons: [
        {
          id: parseInt(d.vidJuniorAllAPack) || 0, size: 10, price: 0,
          name: d.nameJuniorAllAPack || '', img: d.imgJuniorAllA || '', url: d.urlJuniorAllA || '',
          carton: {
            id: parseInt(d.vidJuniorAllACarton) || 0, size: 60, price: 0,
            name: d.nameJuniorAllACarton || '', img: d.imgJuniorAllACarton || ''
          }
        },
        {
          id: parseInt(d.vidJuniorAllBPack) || 0, size: 10, price: 0,
          name: d.nameJuniorAllBPack || '', img: d.imgJuniorAllB || '', url: d.urlJuniorAllB || '',
          carton: {
            id: parseInt(d.vidJuniorAllBCarton) || 0, size: 60, price: 0,
            name: d.nameJuniorAllBCarton || '', img: d.imgJuniorAllBCarton || ''
          }
        }
      ],
      christmas: {
        id: parseInt(d.vidXmasPicPack) || 0, size: 10, price: 0,
        name: d.nameXmasPicPack || '', img: d.imgXmasPic || '', url: d.urlXmasPic || '',
        carton: {
          id: parseInt(d.vidXmasPicCarton) || 0, size: 60, price: 0,
          name: d.nameXmasPicCarton || '', img: d.imgXmasPicCarton || ''
        }
      }
    },
    senior: {
      allseasons: [
        {
          id: parseInt(d.vidSeniorAllAPack) || 0, size: 10, price: 0,
          name: d.nameSeniorAllAPack || '', img: d.imgSeniorAllA || '', url: d.urlSeniorAllA || '',
          carton: {
            id: parseInt(d.vidSeniorAllACarton) || 0, size: 60, price: 0,
            name: d.nameSeniorAllACarton || '', img: d.imgSeniorAllACarton || ''
          }
        },
        {
          id: parseInt(d.vidSeniorAllBPack) || 0, size: 10, price: 0,
          name: d.nameSeniorAllBPack || '', img: d.imgSeniorAllB || '', url: d.urlSeniorAllB || '',
          carton: {
            id: parseInt(d.vidSeniorAllBCarton) || 0, size: 60, price: 0,
            name: d.nameSeniorAllBCarton || '', img: d.imgSeniorAllBCarton || ''
          }
        }
      ],
      christmas: null /* assigned below — shares junior.christmas */
    }
  };
  PRODS.senior.christmas = PRODS.junior.christmas;

  PRODS.grad = {
    single: {
      id: parseInt(d.vidGradSingle) || 0, size: 1, price: 0,
      name: d.nameGradSingle || '', img: d.imgGradSingle || '', url: d.urlGradSingle || ''
    },
    pack: {
      id: parseInt(d.vidGradPack) || 0, size: 10, price: 0,
      name: d.nameGradPack || '', img: d.imgGradPack || '', url: d.urlGradPack || '',
      carton: {
        id: parseInt(d.vidGradCarton) || 0, size: 80, price: 0,
        name: d.nameGradCarton || '', img: d.imgGradCarton || ''
      }
    }
  };

  /* Pre-wrapped Christmas Picture Books: 40-carton minimum — no loose packs offered */
  PRODS.xmas_pic_wrapped = {
    id: 0, size: 10, price: 0,           /* id always 0 — carton-only path in add() */
    name: d.nameXmasPicWrappedCarton || '', img: d.imgWrappedModal || d.imgXmasPicWrappedCarton || '', url: '',
    carton: {
      id: parseInt(d.vidXmasPicWrappedCarton) || 0, size: 40, price: 0,
      name: d.nameXmasPicWrappedCarton || '', img: d.imgXmasPicWrappedCarton || ''
    }
  };

  /* Christmas product IDs (10-pack and carton) — used to split visual into left/right groups */
  var XMAS_IDS = {};
  XMAS_IDS[PRODS.baby.christmas.id]              = true;
  XMAS_IDS[PRODS.baby.christmas.carton.id]       = true;
  XMAS_IDS[PRODS.junior.christmas.id]            = true;
  XMAS_IDS[PRODS.junior.christmas.carton.id]     = true;
  if (PRODS.xmas_pic_wrapped.id)         XMAS_IDS[PRODS.xmas_pic_wrapped.id]         = true;
  if (PRODS.xmas_pic_wrapped.carton.id)  XMAS_IDS[PRODS.xmas_pic_wrapped.carton.id]  = true;

  var PROD_STOCK    = {};           /* variant ID → inventory_quantity */
  var lastXmasSplit = { j: 0, s: 0 }; /* per-age Christmas pack counts for visual display */
  var lastKindyLeftover = 0; /* spare kindy books used by toddler rooms */

  var THEME_FRACTIONS = [1.0, 0.75, 0.5, 0.25, 0];  /* 0 = 100% Christmas, 4 = 100% All-Seasons */

  var themeInteracted = false; /* true once the user touches the theme slider or ticks */
  var calculated      = false; /* true once "Calculate my order" is clicked */
  var _cobVisShown    = false; /* true after first visualizer render — skips thumb animation on re-renders */
  var COB_CALC_KEY    = 'cob_calc_done';

  var state = {
    rooms:    { baby: 0, junior: 0, senior: 0 },
    children: { baby: [], junior: [], senior: [] },
    theme: 0,
    opt:     'variety',  /* 'variety' | 'price' */
    grad:           { enabled: false, chosen: false, count: 0, mode: 'add' },
    wrapped:        false,  /* true = use pre-wrapped Christmas books */
    wrappedChosen:  false   /* true once user has clicked either wrapped button */
  };

  /* Availability flags from theme editor checkboxes */
  var wrappedEnabled = d.wrappedEnabled !== 'false';
  var gradEnabled    = d.gradEnabled    !== 'false';

  var AGE_GROUPS  = ['baby', 'junior', 'senior'];
  var AGE_LABELS  = { baby: 'Baby room', junior: 'Toddler room', senior: 'Kindy room' };

  var elStepChildren  = document.getElementById('cob-step-children');
  var elStepTheme     = document.getElementById('cob-step-theme');
  var elStepGrad      = document.getElementById('cob-step-grad');   /* null when grad disabled */
  var elWrappedOption = document.getElementById('cob-wrapped-option'); /* null when wrapped disabled */
  var elCalcWrap      = document.getElementById('cob-calculate-wrap');
  var elCalcBtn       = document.getElementById('cob-calculate-btn');
  var elResults       = document.getElementById('cob-results');
  var elOptSidebar    = document.getElementById('cob-opt-sidebar');
  var elChildInputs   = document.getElementById('cob-children-inputs');
  var elThemeRange    = document.getElementById('cob-theme-range');
  elThemeRange.classList.add('cob__theme-range--dormant'); /* removed on first interaction */
  var elSummaryItems  = document.getElementById('cob-summary-items');
  var elSummaryFooter = document.getElementById('cob-summary-footer');
  var elOrderTotals   = document.getElementById('cob-order-totals');
  var elTotalPrice    = document.getElementById('cob-total-price');
  var elSubmit        = document.getElementById('cob-submit');
  var elClearCart     = document.getElementById('cob-clear-cart');
  var elProgressClear = document.getElementById('cob-progress-clear');
  var elClearModal    = document.getElementById('cob-clear-modal');
  var elThemeTicks    = section.querySelectorAll('.cob__theme-ticks span');

  /* ---- Teleport modals to <body> ----
     The section has position:relative + z-index:0, which creates a stacking
     context. That traps the modals below the site nav even at z-index:9999.
     Moving them to <body> puts them in the root stacking context so they
     sit above everything. */
  ['cob-product-modal', 'cob-clear-modal', 'cob-info-modal'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) document.body.appendChild(el);
  });

  /* ---- State persistence ---- */
  var COB_STATE_KEY = 'cob_state_v1';
  var COB_ADDED_KEY = 'cob_cart_added';

  function saveState() {
    try {
      localStorage.setItem(COB_STATE_KEY, JSON.stringify({
        rooms: state.rooms, children: state.children,
        theme: state.theme, grad: state.grad, wrapped: state.wrapped, wrappedChosen: state.wrappedChosen
      }));
    } catch(e) {}
  }

  function restoreState() {
    try {
      var saved = JSON.parse(localStorage.getItem(COB_STATE_KEY));
      if (!saved) return;
      if (saved.rooms)               state.rooms    = saved.rooms;
      if (saved.children)            state.children = saved.children;
      if (saved.theme !== undefined)  state.theme   = saved.theme;
      if (saved.grad)                state.grad     = saved.grad;
      if (saved.wrapped !== undefined)       state.wrapped       = saved.wrapped;
      if (saved.wrappedChosen !== undefined) state.wrappedChosen = saved.wrappedChosen;
    } catch(e) {}
  }

  function syncRestoredUi() {
    /* Update stepper displays */
    section.querySelectorAll('.cob__room-row').forEach(function (row) {
      var ag    = row.dataset.age;
      var valEl = row.querySelector('.cob__stepper-val');
      if (valEl) valEl.textContent = state.rooms[ag] || 0;
    });
    /* Restore theme interaction flag */
    if (state.theme !== 0) themeInteracted = true;
    /* Update theme range and opt buttons */
    elThemeRange.classList.toggle('cob__theme-range--dormant', !themeInteracted);
    elThemeRange.value = state.theme;
    section.querySelectorAll('.cob__opt-btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.opt === state.opt);
    });
    /* Restore grad inputs */
    if (state.grad) {
      var gradDetailEl = document.getElementById('cob-grad-detail');
      var gradCountEl  = document.getElementById('cob-grad-count');
      section.querySelectorAll('[data-grad-yn]').forEach(function (b) {
        b.classList.toggle('is-active', state.grad.chosen && ((b.dataset.gradYn === 'yes') === state.grad.enabled));
      });
      if (gradDetailEl) gradDetailEl.hidden = !state.grad.enabled;
      if (gradCountEl)  gradCountEl.value   = state.grad.count;
      var gradRangeEl = document.getElementById('cob-grad-range');
      if (gradRangeEl) { gradRangeEl.value = Math.min(state.grad.count, 100); updateRangeFill(gradRangeEl); }
      section.querySelectorAll('input[name="cob-grad-mode"]').forEach(function (r) {
        r.checked = (r.value === state.grad.mode);
      });
    }
    /* Restore wrapped toggle */
    section.querySelectorAll('[data-wrapped-yn]').forEach(function (b) {
      b.classList.toggle('is-active', (b.dataset.wrappedYn === 'yes') === state.wrapped);
    });
    /* Restore calculated state if there is meaningful saved form state */
    if (sessionStorage.getItem(COB_CALC_KEY)) {
      var hasRoomsR    = AGE_GROUPS.some(function (ag) { return state.rooms[ag] > 0; });
      var hasChildrenR = AGE_GROUPS.some(function (ag) { return sum(state.children[ag]) > 0; });
      if (hasRoomsR && hasChildrenR) {
        calculated      = true;
        themeInteracted = true;
        elThemeRange.classList.remove('cob__theme-range--dormant');
        if (elCalcWrap) elCalcWrap.hidden = true;
        if (elResults)  elResults.hidden  = false;
      }
    }
    /* Show "Update cart" label if items were previously added */
    if (sessionStorage.getItem(COB_ADDED_KEY)) {
      elSubmit.textContent = 'Update cart';
    }
    /* Show clear button if there is anything to clear */
    var hasState = AGE_GROUPS.some(function (ag) { return state.rooms[ag] > 0; }) ||
      AGE_GROUPS.some(function (ag) { return sum(state.children[ag]) > 0; }) ||
      !!sessionStorage.getItem(COB_ADDED_KEY);
    elClearCart.hidden = !hasState;
    if (elProgressClear) elProgressClear.hidden = !hasState;
  }

  /* ---- Progress indicator ---- */
  function updateProgress() {
    var hasRooms    = AGE_GROUPS.some(function (ag) { return state.rooms[ag] > 0; });
    var hasChildren = hasRooms && AGE_GROUPS.some(function (ag) { return sum(state.children[ag]) > 0; });
    /* When grad is disabled there are only 3 steps; cap active at 3 */
    var active = !hasRooms ? 1 : !hasChildren ? 2 : !themeInteracted ? 3 : (gradEnabled ? 4 : 3);
    /* Step 4 shows a tick once grad is answered: No = done; Yes = needs count > 0 */
    var gradComplete = gradEnabled && state.grad && state.grad.chosen &&
                       (!state.grad.enabled || state.grad.count > 0);
    section.querySelectorAll('.cob__progress-step').forEach(function (el) {
      var s = parseInt(el.dataset.step);
      var complete = s < active || (s === 4 && gradComplete);
      el.classList.remove('is-active');
      el.classList.remove('is-complete');
      if (s === active)  el.classList.add('is-active');
      if (complete)      el.classList.add('is-complete');
    });
    section.querySelectorAll('.cob__progress-connector').forEach(function (el, i) {
      el.classList.toggle('is-complete', i + 1 < active);
    });
  }

  /* ---- Step visibility with reveal animation ---- */
  function setStepVisible(el, visible) {
    if (!el) return;
    if (visible && el.hidden) {
      el.hidden = false;
      el.classList.remove('cob__step--reveal');
      void el.offsetWidth; /* force reflow so animation replays */
      el.classList.add('cob__step--reveal');
    } else if (!visible && !el.hidden) {
      el.hidden = true;
      el.classList.remove('cob__step--reveal');
    }
  }

  /* ---- Stepper buttons ---- */
  section.querySelectorAll('.cob__room-row').forEach(function (row) {
    var ag    = row.dataset.age;
    var valEl = row.querySelector('.cob__stepper-val');
    row.querySelectorAll('.cob__stepper-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.rooms[ag] = Math.max(0, Math.min(9, state.rooms[ag] + parseInt(btn.dataset.dir)));
        valEl.textContent = state.rooms[ag];
        var prev = state.children[ag];
        state.children[ag] = Array.from({ length: state.rooms[ag] }, function (_, i) {
          return prev[i] || 0;
        });
        renderChildren();
        update();
      });
    });
  });

  /* ---- Optimisation toggle ---- */
  var OPT_HINTS = {
    variety: 'Maximises the number of titles across your order.',
    price:   'Upgrades to a carton wherever possible.'
  };
  /* Scope to [data-opt] only — avoids stripping is-active from grad/wrapped toggles */
  section.querySelectorAll('[data-opt]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      section.querySelectorAll('[data-opt]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      state.opt = btn.dataset.opt;
      update();
    });
  });

  /* ---- Graduation inputs ---- */
  (function () {
    var gradDetail  = document.getElementById('cob-grad-detail');
    var gradCount   = document.getElementById('cob-grad-count');
    var gradRange   = document.getElementById('cob-grad-range');
    if (!gradDetail || !gradCount) return;

    /* Yes / No toggle */
    section.querySelectorAll('[data-grad-yn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        section.querySelectorAll('[data-grad-yn]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.grad.enabled = (btn.dataset.gradYn === 'yes');
        state.grad.chosen  = true;
        gradDetail.hidden = !state.grad.enabled;
        update();
      });
    });

    /* Count number input */
    gradCount.addEventListener('click', function () { gradCount.select(); });
    gradCount.addEventListener('input', function () {
      var v = Math.max(1, parseInt(gradCount.value) || 1);
      state.grad.count = v;
      if (gradRange) { gradRange.value = Math.min(v, 100); updateRangeFill(gradRange); }
      update();
    });

    /* Count range slider */
    if (gradRange) {
      gradRange.addEventListener('input', function () {
        var v = parseInt(gradRange.value);
        state.grad.count = v;
        gradCount.value = v;
        updateRangeFill(gradRange);
        update();
      });
      updateRangeFill(gradRange);
    }

    /* Add / Replace radio */
    section.querySelectorAll('input[name="cob-grad-mode"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        state.grad.mode = radio.value;
        update();
      });
    });
  }());

  /* ---- Pre-wrapped toggle ---- */
  section.querySelectorAll('[data-wrapped-yn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      section.querySelectorAll('[data-wrapped-yn]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      state.wrapped       = (btn.dataset.wrappedYn === 'yes');
      state.wrappedChosen = true;
      /* Toggling after add to cart should revert submit button to "Update cart" */
      if (elSubmit && elSubmit.dataset.cobGoCart && sessionStorage.getItem(COB_ADDED_KEY)) {
        delete elSubmit.dataset.cobGoCart;
        elSubmit.textContent = 'Update cart';
      }
      update();
    });
  });

  /* ---- Calculate button ---- */
  if (elCalcBtn) {
    elCalcBtn.addEventListener('click', function () {
      calculated = true;
      try { sessionStorage.setItem(COB_CALC_KEY, '1'); } catch(e) {}
      elCalcWrap.hidden = true;
      elResults.hidden = false;
      update();
    });
  }

  /* ---- Theme slider ---- */
  function activateTheme() {
    if (!themeInteracted) {
      themeInteracted = true;
      elThemeRange.classList.remove('cob__theme-range--dormant');
      updateThemeUi();
      update();
    }
  }

  elThemeRange.addEventListener('pointerdown', activateTheme);
  elThemeRange.addEventListener('input', function () {
    activateTheme();
    state.theme = parseInt(elThemeRange.value);
    updateThemeUi();
    update();
  });

  /* Tick labels are also clickable — clicking a label snaps the slider to that position */
  elThemeTicks.forEach(function (tick, i) {
    tick.addEventListener('click', function () {
      activateTheme();
      state.theme = i;
      elThemeRange.value = i;
      updateThemeUi();
      update();
    });
  });

  function updateThemeUi() {
    var t = state.theme / 4;
    /* t=0 → Christmas red #d90007; t=1 → All-Seasons teal #4f8898 */
    var r = Math.round(217 - 138 * t);
    var g = Math.round(0   + 136 * t);
    var b = Math.round(7   + 145 * t);
    var thumbColor = 'rgb(' + r + ',' + g + ',' + b + ')';
    elThemeRange.style.setProperty('--cob-thumb-color', thumbColor);
    elThemeTicks.forEach(function (tick, i) {
      /* No tick highlighted until the user has actively chosen a theme */
      if (!themeInteracted) {
        tick.classList.remove('is-active');
        tick.style.color = '';
      } else {
        tick.classList.toggle('is-active', i === state.theme);
        if (i === state.theme) tick.style.color = thumbColor;
        else tick.style.color = '';
      }
    });
  }

  /* ---- Render children inputs ---- */
  function renderChildren() {
    var hasRooms = AGE_GROUPS.some(function (ag) { return state.rooms[ag] > 0; });
    setStepVisible(elStepChildren, hasRooms);
    if (!hasRooms) { elChildInputs.innerHTML = ''; updateProgress(); return; }

    var html = '';
    /* Find which age groups have rooms so we can identify the last one */
    var activeGroups = AGE_GROUPS.filter(function (ag) { return state.rooms[ag] > 0; });
    var lastGroup    = activeGroups[activeGroups.length - 1];
    AGE_GROUPS.forEach(function (ag) {
      var count = state.rooms[ag];
      for (var i = 0; i < count; i++) {
        var label       = count === 1 ? AGE_LABELS[ag] : AGE_LABELS[ag] + ' ' + (i + 1);
        var val         = state.children[ag][i] || 0;
        var numId       = 'cob-num-' + ag + '-' + i;
        var rngId       = 'cob-rng-' + ag + '-' + i;
        /* Add age-end class to the last room row of each age group, except the last group */
        var isLastInGroup = (i === count - 1);
        var isLastGroup   = (ag === lastGroup);
        var rowClass = 'cob__child-row' + (isLastInGroup && !isLastGroup ? ' cob__child-row--age-end' : '');
        html +=
          '<div class="' + rowClass + '">' +
            '<label class="cob__child-label" for="' + rngId + '">' + label + '</label>' +
            '<input class="cob__child-range" type="range" id="' + rngId + '"' +
              ' data-age="' + ag + '" data-idx="' + i + '" data-pair="' + numId + '"' +
              ' min="0" max="100" step="1" value="' + Math.min(val, 100) + '">' +
            '<input class="cob__child-num" type="number" id="' + numId + '"' +
              ' data-age="' + ag + '" data-idx="' + i + '" data-pair="' + rngId + '"' +
              ' min="0" max="999" value="' + val + '" placeholder="0">' +
          '</div>';
      }
    });
    elChildInputs.innerHTML = html;

    elChildInputs.querySelectorAll('.cob__child-num').forEach(function (inp) {
      inp.addEventListener('click', function () { inp.select(); });
      inp.addEventListener('input', function () {
        var v = Math.max(0, parseInt(inp.value) || 0);
        state.children[inp.dataset.age][parseInt(inp.dataset.idx)] = v;
        var rng = document.getElementById(inp.dataset.pair);
        if (rng) { rng.value = Math.min(v, 100); updateRangeFill(rng); }
        update();
      });
    });

    elChildInputs.querySelectorAll('.cob__child-range').forEach(function (rng) {
      rng.addEventListener('input', function () {
        var v = parseInt(rng.value);
        state.children[rng.dataset.age][parseInt(rng.dataset.idx)] = v;
        var num = document.getElementById(rng.dataset.pair);
        if (num) num.value = v;
        updateRangeFill(rng);
        update();
      });
      updateRangeFill(rng);
    });
  }

  function updateRangeFill(rng) {
    if (!rng) return;
    var pct = (parseInt(rng.value) / parseInt(rng.max || 100)) * 100;
    var grad = 'linear-gradient(to right, var(--cob-accent) 0%, var(--cob-accent) ' + pct + '%, #e5ddd8 ' + pct + '%, #e5ddd8 100%)';
    rng.style.setProperty('--cob-range-fill', grad);
    rng.style.background = grad; /* Firefox fallback */
  }

  /* ---- Calculate order items ---- */
  function calcItems() {
    var fraction = THEME_FRACTIONS[state.theme];
    var map = {};

    function add(prod, qty, ageTag) {
      if (qty <= 0) return;

      /* Map keys incorporate ageTag so the same product can appear in multiple age rows */
      var packKey   = ageTag !== undefined ? (prod.id + '_' + ageTag) : prod.id;
      var cartonKey = ageTag !== undefined ? (prod.carton ? (prod.carton.id + '_' + ageTag) : null) : (prod.carton ? prod.carton.id : null);

      /* Carton-only product (no pack variant configured): ceil all packs into cartons */
      if (prod.id === 0 && prod.carton && prod.carton.id > 0) {
        var cartonCapInPacks0 = Math.floor(prod.carton.size / prod.size);
        var cartonQty0 = Math.ceil(qty / cartonCapInPacks0);
        var c0 = prod.carton;
        if (map[cartonKey]) { map[cartonKey].qty += cartonQty0; }
        else { map[cartonKey] = { id: c0.id, qty: cartonQty0, name: c0.name, price: c0.price, size: c0.size, img: c0.img, unit: 'carton', packId: 0, url: prod.url || '', ageTag: ageTag }; }
        return;
      }

      var cartons = 0, loose = qty;
      if (prod.carton && prod.price > 0) {
        var cartonThreshold  = Math.ceil(prod.carton.price / prod.price);
        var cartonCapInPacks = Math.floor(prod.carton.size / prod.size);
        var remaining        = qty;
        while (remaining >= cartonThreshold) {
          cartons++;
          remaining = Math.max(0, remaining - cartonCapInPacks);
        }
        loose = remaining;
      }

      if (cartons > 0 && cartonKey) {
        var c = prod.carton;
        if (map[cartonKey]) { map[cartonKey].qty += cartons; }
        else { map[cartonKey] = { id: c.id, qty: cartons, name: c.name, price: c.price, size: c.size, img: c.img, unit: 'carton', packId: prod.id, url: prod.url || '', ageTag: ageTag }; }
      }
      if (loose > 0) {
        if (map[packKey]) { map[packKey].qty += loose; }
        else { map[packKey] = { id: prod.id, qty: loose, name: prod.name, price: prod.price, size: prod.size, img: prod.img, unit: 'pack', packId: prod.id, url: prod.url || '', ageTag: ageTag }; }
      }
    }

    /* Balanced Best Price: sub-carton = even split; carton+ = alternate cartons, remainder to next set */
    function balancedAdd(prodA, prodB, totalPacks) {
      if (totalPacks <= 0) return;
      var first  = stockChoice(prodA, prodB);
      var second = first === prodA ? prodB : prodA;
      var cartonPacks = first.carton && first.carton.id && first.size > 0
        ? Math.floor(first.carton.size / first.size) : Infinity;
      if (totalPacks < cartonPacks) {
        add(first,  Math.ceil(totalPacks  / 2));
        add(second, Math.floor(totalPacks / 2));
        return;
      }
      var aCount = 0, bCount = 0, remaining = totalPacks, turn = 'first';
      while (remaining >= cartonPacks) {
        if (turn === 'first') { aCount += cartonPacks; turn = 'second'; }
        else                  { bCount += cartonPacks; turn = 'first';  }
        remaining -= cartonPacks;
      }
      if (remaining > 0) {
        if (turn === 'first') aCount += remaining;
        else                  bCount += remaining;
      }
      if (aCount > 0) add(first,  aCount);
      if (bCount > 0) add(second, bCount);
    }

    /* Graduation books: price-based carton upgrade (mirrors add() logic).
       Convert children to packs, then greedily upgrade to 80-carton when
       N packs cost >= 1 carton. Remainder rounds up to a 10-pack (no singles). */
    function addGrad(count) {
      if (count <= 0) return;
      var packQty = Math.ceil(count / 10);
      var gCartons = 0, loosePacks = packQty;

      if (PRODS.grad.pack.carton && PRODS.grad.pack.carton.id &&
          PRODS.grad.pack.price > 0 && PRODS.grad.pack.carton.price > 0) {
        var gCartonThreshold = Math.ceil(PRODS.grad.pack.carton.price / PRODS.grad.pack.price);
        var gCartonCap       = Math.floor(PRODS.grad.pack.carton.size  / PRODS.grad.pack.size);
        var rem = packQty;
        while (rem >= gCartonThreshold) {
          gCartons++;
          rem = Math.max(0, rem - gCartonCap);
        }
        loosePacks = rem;
      }

      if (gCartons > 0) {
        var gc = PRODS.grad.pack.carton;
        var gcKey = gc.id + '_grad';
        if (map[gcKey]) { map[gcKey].qty += gCartons; }
        else { map[gcKey] = { id: gc.id, qty: gCartons, name: gc.name, price: gc.price, size: gc.size, img: gc.img, unit: 'carton', packId: PRODS.grad.pack.id, url: PRODS.grad.pack.url || '', ageTag: 3 }; }
      }
      if (loosePacks > 0 && PRODS.grad.pack.id) {
        var gp = PRODS.grad.pack;
        var gpKey = gp.id + '_grad';
        if (map[gpKey]) { map[gpKey].qty += loosePacks; }
        else { map[gpKey] = { id: gp.id, qty: loosePacks, name: gp.name, price: gp.price, size: gp.size, img: gp.img, unit: 'pack', packId: gp.id, url: gp.url || '', ageTag: 3 }; }
      }
    }

    /* Baby (0-2): split children by theme fraction, round up per pack type */
    var babyTotal = sum(state.children.baby);
    if (babyTotal > 0) {
      var babyXmas = Math.round(babyTotal * fraction);
      var babyAll  = babyTotal - babyXmas;
      if (babyXmas > 0) add(PRODS.baby.christmas,  Math.ceil(babyXmas / PRODS.baby.christmas.size));
      if (babyAll  > 0) add(PRODS.baby.allseasons, Math.ceil(babyAll  / PRODS.baby.allseasons.size));
    }

    /*
     * Junior (2-3) and Senior (4-6) are ordered independently.
     * Each age group gets exactly ceil(children/10) packs of their own titles.
     * No sharing between age groups.
     */
    var juniorTotal     = sum(state.children.junior);
    var seniorRaw       = sum(state.children.senior);
    var gradReplaceCount = (state.grad && state.grad.enabled && state.grad.mode === 'replace' && state.grad.count > 0)
      ? Math.min(state.grad.count, seniorRaw) : 0;
    var seniorTotal     = seniorRaw - gradReplaceCount;
    var pictureTotal    = juniorTotal + seniorTotal;

    if (pictureTotal <= 0) { lastXmasSplit.j = 0; lastXmasSplit.s = 0; }
    if (pictureTotal > 0) {
      var juniorPacks = Math.ceil(juniorTotal / 10);
      var seniorPacks = Math.ceil(seniorTotal / 10);

      /* Apply fraction per age group so each group gets its correct ratio independently.
         Pooling into a single fraction can starve one age group of All-Seasons books. */
      var sXmasPacks = Math.round(seniorPacks * fraction);
      var sAllPacks  = seniorPacks - sXmasPacks;
      var jXmasPacks = Math.round(juniorPacks * fraction);
      var jAllPacks  = juniorPacks - jXmasPacks;

      /* Store per-age split for visual display, then combine for optimal carton upgrade in cart */
      lastXmasSplit.j = jXmasPacks; lastXmasSplit.s = sXmasPacks;
      lastKindyLeftover = (juniorTotal > 0 && juniorPacks * 10 < juniorTotal) ? juniorTotal - juniorPacks * 10 : 0;
      /* Wrapped = floor to 40-book cartons; remainder as standard unwrapped packs */
      var hasWrappedProd = PRODS.xmas_pic_wrapped.carton && PRODS.xmas_pic_wrapped.carton.id > 0;
      var totalXmasPacks = jXmasPacks + sXmasPacks;
      if (totalXmasPacks > 0) {
        if (state.wrapped && wrappedEnabled && hasWrappedProd) {
          var wCartonCap    = Math.floor(PRODS.xmas_pic_wrapped.carton.size / PRODS.xmas_pic_wrapped.size); /* = 4 */
          var wrappedCartons = Math.floor(totalXmasPacks / wCartonCap);
          var unwrappedPacks = totalXmasPacks - wrappedCartons * wCartonCap;
          if (wrappedCartons > 0) {
            var wc = PRODS.xmas_pic_wrapped.carton;
            var wcKey = wc.id;
            if (map[wcKey]) { map[wcKey].qty += wrappedCartons; }
            else { map[wcKey] = { id: wc.id, qty: wrappedCartons, name: wc.name, price: wc.price, size: wc.size, img: wc.img, unit: 'carton', packId: 0, url: PRODS.xmas_pic_wrapped.url || '', ageTag: undefined }; }
          }
          if (unwrappedPacks > 0) add(PRODS.junior.christmas, unwrappedPacks);
        } else {
          add(PRODS.junior.christmas, totalXmasPacks);
        }
      }

      if (state.opt === 'price') {
        if (sAllPacks > 0) balancedAdd(PRODS.senior.allseasons[0], PRODS.senior.allseasons[1], sAllPacks);
        if (jAllPacks > 0) balancedAdd(PRODS.junior.allseasons[0], PRODS.junior.allseasons[1], jAllPacks);
      } else {
        if (sAllPacks > 0) {
          add(PRODS.senior.allseasons[0], Math.ceil(sAllPacks / 2));
          add(PRODS.senior.allseasons[1], Math.floor(sAllPacks / 2));
        }
        if (jAllPacks > 0) {
          add(PRODS.junior.allseasons[0], Math.ceil(jAllPacks / 2));
          add(PRODS.junior.allseasons[1], Math.floor(jAllPacks / 2));
        }
      }
    }

    /* Graduation books */
    if (state.grad && state.grad.enabled && state.grad.count > 0) {
      addGrad(state.grad.count);
    }

    return Object.values(map).filter(function (item) { return item.qty > 0; });
  }

  /* ---- Update summary panel ---- */
  function update() {
    /* If user changes anything after adding to cart, revert button to "Update cart" */
    if (elSubmit && elSubmit.dataset.cobGoCart && sessionStorage.getItem(COB_ADDED_KEY)) {
      delete elSubmit.dataset.cobGoCart;
      elSubmit.textContent = 'Update cart';
    }

    var totalChildren = AGE_GROUPS.reduce(function (s, ag) { return s + sum(state.children[ag]); }, 0);
    var hasRooms = AGE_GROUPS.some(function (ag) { return state.rooms[ag] > 0; });

    /* Total enrolment display */
    var elEnrolTotal = document.getElementById('cob-enrolment-total');
    var elEnrolVal   = document.getElementById('cob-enrolment-val');
    if (elEnrolTotal && elEnrolVal) {
      elEnrolVal.textContent = totalChildren + (totalChildren === 1 ? ' child' : ' children');
      elEnrolTotal.hidden = !hasRooms || totalChildren === 0;
    }

    setStepVisible(elStepTheme, hasRooms && totalChildren > 0);

    /* Pre-wrapped option: visible when Christmas fraction > 0 and theme has been interacted */
    var xmasFraction = THEME_FRACTIONS[state.theme];
    var wrappedVisible = wrappedEnabled && themeInteracted && xmasFraction > 0;
    if (elWrappedOption) elWrappedOption.hidden = !wrappedVisible;

    /* Step 4 opens only after wrapped choice is made (or wrapped option isn't showing) */
    var wrappedAnswered = !wrappedVisible || state.wrappedChosen;
    var gradStepReady = themeInteracted && totalChildren > 0 && wrappedAnswered;
    /* When grad option is disabled, grad counts as answered (no) */
    var readyToCalc   = gradStepReady && (state.grad.chosen || !gradEnabled);
    if (gradEnabled) setStepVisible(elStepGrad, gradStepReady);
    if (elCalcWrap) elCalcWrap.hidden = !readyToCalc || calculated;
    if (elResults)  elResults.hidden  = !calculated;
    updateProgress();
    if (elOptSidebar) elOptSidebar.hidden = !modesDiffer();

    /* Hold off on showing the order until Calculate is clicked */
    if (!calculated) {
      saveState();
      var hasAnythingEarly = AGE_GROUPS.some(function (ag) { return state.rooms[ag] > 0; }) ||
        AGE_GROUPS.some(function (ag) { return sum(state.children[ag]) > 0; }) ||
        !!sessionStorage.getItem(COB_ADDED_KEY);
      elClearCart.hidden = !hasAnythingEarly;
      if (elProgressClear) elProgressClear.hidden = !hasAnythingEarly;
      return;
    }

    var items = calcItems();
    if (items.length === 0) {
      elSummaryItems.innerHTML = '<p class="cob__summary-empty">Add your rooms above to see your recommended order.</p>';
      elSummaryFooter.hidden = true;
      if (elOrderTotals) elOrderTotals.hidden = true;
      renderThemeVisual([]);
      return;
    }

    /* Sort to match visual order: age group → Christmas first → carton first → alphabetical */
    items.sort(function (a, b) {
      var ag = itemAgeGroup(a) - itemAgeGroup(b);
      if (ag !== 0) return ag;
      var xa = XMAS_IDS[a.id] ? 0 : 1, xb = XMAS_IDS[b.id] ? 0 : 1;
      if (xa !== xb) return xa - xb;
      var ua = a.unit === 'carton' ? 0 : (a.unit === 'pack' ? 1 : 2);
      var ub = b.unit === 'carton' ? 0 : (b.unit === 'pack' ? 1 : 2);
      if (ua !== ub) return ua - ub;
      return a.name.localeCompare(b.name);
    });

    /* Merge items with the same product ID (e.g. Christmas split across age groups) for display */
    var mergedMap = {}, mergedOrder = [];
    items.forEach(function (item) {
      var key = item.id + '_' + item.unit; /* keep carton and pack as separate lines */
      if (mergedMap[key]) {
        mergedMap[key].qty += item.qty;
      } else {
        mergedMap[key] = { id: item.id, qty: item.qty, name: item.name, price: item.price, size: item.size, unit: item.unit };
        mergedOrder.push(key);
      }
    });
    var displayItems = mergedOrder.map(function (k) { return mergedMap[k]; });

    var grandTotal = 0;
    var totalBooks = 0;
    var html = '';
    displayItems.forEach(function (item) {
      var lineTotal = item.price * item.qty;
      grandTotal += lineTotal;
      totalBooks  += item.qty * item.size;
      var packWord = item.unit === 'carton'
        ? (item.qty === 1 ? 'carton' : 'cartons')
        : item.unit === 'single'
          ? (item.qty === 1 ? 'book' : 'books')
          : (item.qty === 1 ? 'pack' : 'packs');
      html +=
        '<div class="cob__summary-line" data-variant-id="' + item.id + '">' +
          '<span class="cob__summary-line-name">' + item.name + '</span>' +
          '<span class="cob__summary-line-qty">' + item.qty + '&nbsp;' + packWord + '</span>' +
          '<span class="cob__summary-line-price">' + fmt(lineTotal) + '</span>' +
        '</div>';
    });
    elSummaryItems.innerHTML = html;

    renderThemeVisual(buildVisualItems(items, lastXmasSplit.j, lastXmasSplit.s));

    /* Split stats: end-of-year gifts vs graduation gifts */
    var gradItems   = items.filter(function(i) { return i.ageTag === 3; });
    var eoyItems    = items.filter(function(i) { return i.ageTag !== 3; });
    var eoyBooks    = eoyItems.reduce(function(s,i) { return s + i.qty*i.size; }, 0);
    var eoyGrand    = eoyItems.reduce(function(s,i) { return s + i.qty*i.price; }, 0);
    var gradBooks2  = gradItems.reduce(function(s,i) { return s + i.qty*i.size; }, 0);
    var gradGrand   = gradItems.reduce(function(s,i) { return s + i.qty*i.price; }, 0);
    var eoyChildren = (state.grad && state.grad.enabled && state.grad.mode === 'replace')
      ? Math.max(0, totalChildren - state.grad.count) : totalChildren;

    /* Populate EOY column */
    var eoyCol = document.getElementById('cob-totals-eoy');
    if (eoyCol) {
      eoyCol.innerHTML =
        '<p class="cob__totals-label">End-of-year gifts</p>' +
        stat('Children', eoyChildren) +
        stat('End-of-year gift books', eoyBooks) +
        stat('Price per book', fmt(eoyBooks > 0 ? eoyGrand / eoyBooks : 0));
    }

    /* Populate Grad column — hide column when no grad items */
    var gradCol = document.getElementById('cob-totals-grad');
    if (gradCol) {
      gradCol.hidden = (gradBooks2 === 0);
      if (gradBooks2 > 0) {
        gradCol.innerHTML =
          '<p class="cob__totals-label">Graduation gifts</p>' +
          stat('Children', state.grad.count) +
          stat('Graduation books', gradBooks2) +
          stat('Price per book', fmt(gradBooks2 > 0 ? gradGrand / gradBooks2 : 0));
      }
    }
    elTotalPrice.textContent = fmt(grandTotal);

    /* Secondary stats below total */
    var secEl = document.getElementById('cob-totals-secondary');
    if (secEl) {
      var totalBooksAll = eoyBooks + gradBooks2;
      var avgPrice = totalBooksAll > 0 ? grandTotal / totalBooksAll : 0;
      secEl.innerHTML =
        stat('Total books', totalBooksAll) +
        stat('Avg price per book', fmt(avgPrice));
    }

    elSummaryFooter.hidden = false;
    if (elOrderTotals) elOrderTotals.hidden = false;
    saveState();

    /* Show clear button whenever there's something to clear */
    var hasAnything = AGE_GROUPS.some(function (ag) { return state.rooms[ag] > 0; }) ||
      AGE_GROUPS.some(function (ag) { return sum(state.children[ag]) > 0; }) ||
      !!sessionStorage.getItem(COB_ADDED_KEY);
    elClearCart.hidden = !hasAnything;
    if (elProgressClear) elProgressClear.hidden = !hasAnything;
  }

  /* ---- Age group helper ---- */
  function itemAgeGroup(item) {
    if (item.ageTag !== undefined) return item.ageTag;
    var pid = item.packId;
    if (pid === PRODS.baby.allseasons.id || pid === PRODS.baby.christmas.id) return 0;
    if (PRODS.junior.allseasons.some(function (p) { return p.id === pid; }) ||
        pid === PRODS.junior.christmas.id) return 1;
    return 2;
  }

  /* Builds display-only items for the visual. Christmas picture books are split by age group
     and shown as: carton image if that age group hits the carton threshold on its own,
     otherwise just 10-pack images. Cart items remain unchanged. */
  function buildVisualItems(cartItems, jXmas, sXmas) {
    var nonXmasPic = cartItems.filter(function (i) {
      /* Keep all non-Christmas items, plus baby Christmas (board books — not split) */
      return !XMAS_IDS[i.id] || i.packId === PRODS.baby.christmas.id || i.id === PRODS.baby.christmas.carton.id;
    });

    var hasWrappedProdVis = PRODS.xmas_pic_wrapped.carton && PRODS.xmas_pic_wrapped.carton.id > 0;

    var xmasVisual = [];
    function addXmasVisual(prod, packs, ageTag) {
      if (!packs || !prod) return;

      /* Carton-only product (no pack variant): ceil all packs into cartons */
      if (prod.id === 0 && prod.carton && prod.carton.id > 0) {
        var cartonCap0 = Math.floor(prod.carton.size / prod.size);
        var cartonQty0 = Math.ceil(packs / cartonCap0);
        var c0 = prod.carton;
        xmasVisual.push({ id: c0.id, qty: cartonQty0, name: c0.name, price: c0.price, size: c0.size,
          img: c0.img, unit: 'carton', packId: 0, url: prod.url || '', ageTag: ageTag });
        return;
      }

      if (!prod.id) return;
      var threshold   = prod.carton && prod.price > 0 ? Math.ceil(prod.carton.price / prod.price) : Infinity;
      var cartonCap   = prod.carton ? Math.floor(prod.carton.size / prod.size) : 0;
      var cartons = 0, loose = packs;
      if (cartonCap > 0 && packs >= threshold) {
        var rem = packs;
        while (rem >= threshold) { cartons++; rem = Math.max(0, rem - cartonCap); }
        loose = rem;
      }
      if (cartons > 0) {
        var c = prod.carton;
        xmasVisual.push({ id: c.id, qty: cartons, name: c.name, price: c.price, size: c.size,
          img: c.img, unit: 'carton', packId: prod.id, url: prod.url || '', ageTag: ageTag });
      }
      if (loose > 0) {
        xmasVisual.push({ id: prod.id, qty: loose, name: prod.name, price: prod.price, size: prod.size,
          img: prod.img, unit: 'pack', packId: prod.id, url: prod.url || '', ageTag: ageTag });
      }
    }

    if (state.wrapped && wrappedEnabled && hasWrappedProdVis) {
      /* Mirror the cart logic: floor to wrapped cartons, show remainder as standard packs */
      var wCartonCapVis   = Math.floor(PRODS.xmas_pic_wrapped.carton.size / PRODS.xmas_pic_wrapped.size);
      var wrappedCartonsV = Math.floor((jXmas + sXmas) / wCartonCapVis);
      var unwrappedPacksV = (jXmas + sXmas) - wrappedCartonsV * wCartonCapVis;
      if (wrappedCartonsV > 0) {
        var wcv = PRODS.xmas_pic_wrapped.carton;
        xmasVisual.push({ id: wcv.id, qty: wrappedCartonsV, name: wcv.name, price: wcv.price,
          size: wcv.size, img: PRODS.xmas_pic_wrapped.img || wcv.img, unit: 'carton',
          packId: 0, url: PRODS.xmas_pic_wrapped.url || '', ageTag: 1 });
      }
      if (unwrappedPacksV > 0) addXmasVisual(PRODS.junior.christmas, unwrappedPacksV, 1);
    } else {
      addXmasVisual(PRODS.junior.christmas, jXmas, 1);
      addXmasVisual(PRODS.junior.christmas, sXmas, 2);
    }

    return nonXmasPic.concat(xmasVisual);
  }

  function modalPackDesc(item) {
    if (item.price > 0) {
      if (item.size === 1) return fmt(item.price) + ' per book';
      return fmt(item.price) + ' per ' + (item.unit === 'carton' ? 'carton' : 'pack') +
             ' \xb7 ' + fmt(item.price / item.size) + ' per book';
    }
    if (item.size === 1) return 'Single book';
    return item.size + ' books per ' + (item.unit === 'carton' ? 'carton' : 'pack');
  }

  /* ---- Theme visual: one left-aligned row per age group.
     Christmas items on left, All-Seasons on right.
     Within each product group: cartons left, loose packs right.
     Cards fan/overlap within the same product; different products get a gap. ---- */
  function renderThemeVisual(items) {
    var elVis  = document.getElementById('cob-theme-visual');
    var elRows = document.getElementById('cob-vis-rows');
    if (!elVis || !elRows) return;

    /* Only show after Calculate is clicked */
    if (!calculated || items.length === 0) {
      while (elRows.firstChild) elRows.removeChild(elRows.firstChild);
      _cobVisShown = false;
      elVis.hidden = true;
      return;
    }

    /* Slide in on first reveal only */
    var isFirstReveal = !_cobVisShown;
    if (isFirstReveal) {
      elVis.hidden = false;
      elVis.classList.remove('cob__vis--reveal');
      void elVis.offsetWidth;
      elVis.classList.add('cob__vis--reveal');
      _cobVisShown = true;
    }
    while (elRows.firstChild) elRows.removeChild(elRows.firstChild);

    var isMobile  = window.innerWidth < 750;
    var THUMB     = isMobile ? 64 : 96;
    var STEP      = Math.round(THUMB * 0.38);
    var GAP       = isMobile ? 12 : 18;
    var SECT_GAP  = isMobile ? 20 : 32;

    var AGE_LABELS     = ['Baby rooms', 'Toddler rooms', 'Kindy rooms', 'Graduates'];
    var AGE_BOOK_TYPES = ['12cm board books', '25cm picture books', '25cm picture books', 'Graduation books'];
    var AGE_CHILDREN = [
      sum(state.children.baby),
      sum(state.children.junior),
      sum(state.children.senior),
      (state.grad && state.grad.enabled ? state.grad.count : 0)
    ];

    /* Max row width for wrapping — derived from the visual container */
    var maxRowPx = Math.max(200, elVis.clientWidth - 44);

    var thumbIndex = 0;
    [0, 1, 2, 3].forEach(function (ag) {
      var xmasItems = items.filter(function (i) { return itemAgeGroup(i) === ag &&  XMAS_IDS[i.id]; });
      var allItems  = items.filter(function (i) { return itemAgeGroup(i) === ag && !XMAS_IDS[i.id]; });
      if (!xmasItems.length && !allItems.length) return;

      var row = document.createElement('div');
      row.className = 'cob__vis-age-row';
      var x = 0;
      var rowY = 0; /* current visual row Y offset within this age group */

      function renderSection(sectionItems) {
        var groups = {}, groupOrder = [];
        sectionItems.forEach(function (item) {
          var pid = item.packId || item.id;
          if (!groups[pid]) { groups[pid] = []; groupOrder.push(pid); }
          groups[pid].push(item);
        });

        groupOrder.forEach(function (pid, gi) {
          if (gi > 0) x += GAP;
          /* Cartons left, loose packs right within each product group */
          var grp = groups[pid].slice().sort(function (a, b) {
            return (a.unit === 'carton' ? 0 : 1) - (b.unit === 'carton' ? 0 : 1);
          });
          grp.forEach(function (item) {
            var count = Math.min(item.qty, 13);
            for (var k = 0; k < count; k++) {
              /* Wrap to a new picture row if this thumb would overflow */
              if (x + k * STEP + THUMB > maxRowPx && (x > 0 || k > 0)) {
                rowY += THUMB + 10;
                x = 0;
                k = 0;
              }
              var tImg = makeThumb(item.img, x + k * STEP, THUMB,
                item.name, modalPackDesc(item), item.url || '');
              tImg.style.top = rowY + 'px';
              if (isFirstReveal) {
                tImg.classList.add('cob__vis-thumb--anim');
                tImg.style.animationDelay = (thumbIndex * 35) + 'ms';
                thumbIndex++;
              }
              row.appendChild(tImg);
            }
            x += (count - 1) * STEP + THUMB;
          });
        });
      }

      renderSection(xmasItems);
      if (xmasItems.length && allItems.length) {
        /* Wrap before All-Seasons section if it won't fit on current row */
        if (x + SECT_GAP + THUMB > maxRowPx) { rowY += THUMB + 10; x = 0; }
        else { x += SECT_GAP; }
      }
      renderSection(allItems);

      row.style.width  = Math.min(x, maxRowPx) + 'px';
      row.style.height = (rowY + THUMB) + 'px';

      /* Summary line: children · books · price/book */
      var rowItems = xmasItems.concat(allItems);
      var rowBooks = rowItems.reduce(function (s, i) { return s + i.qty * i.size; }, 0);
      var gradReplaceCount = (ag === 2 && state.grad && state.grad.enabled && state.grad.mode === 'replace' && state.grad.count > 0)
        ? Math.min(state.grad.count, sum(state.children.senior)) : 0;
      var children = AGE_CHILDREN[ag] - (ag === 2 ? gradReplaceCount : 0);
      var summary = document.createElement('div');
      summary.className = 'cob__vis-row-summary';

      var labelLine = document.createElement('p');
      labelLine.className = 'cob__vis-row-label';
      labelLine.innerHTML = '<strong>' + AGE_LABELS[ag] + '</strong> &middot; ' + AGE_BOOK_TYPES[ag];
      summary.appendChild(labelLine);

      var statsArr = [];
      if (children > 0) statsArr.push(children + ' children');
      if (rowBooks  > 0) statsArr.push(rowBooks + ' books');
      if (statsArr.length > 0) {
        var statsLine = document.createElement('p');
        statsLine.className = 'cob__vis-row-stats';
        var statsText = statsArr.join(' \xb7 ');
        if (ag === 1 && lastKindyLeftover > 0) {
          statsText += ' (use ' + lastKindyLeftover + ' leftover book' + (lastKindyLeftover === 1 ? '' : 's') + ' from Kindy rooms)';
        }
        if (ag === 2 && gradReplaceCount > 0) {
          statsText += ' (+ ' + gradReplaceCount + ' graduating)';
        }
        statsLine.textContent = statsText;
        summary.appendChild(statsLine);
      }

      var group = document.createElement('div');
      group.className = 'cob__vis-age-group';
      group.appendChild(row);
      group.appendChild(summary);
      elRows.appendChild(group);
    });
  }

  function makeThumb(src, x, size, name, packDesc, url) {
    var img        = document.createElement('img');
    img.className  = 'cob__vis-thumb';
    img.src        = src;
    img.alt        = name || '';
    img.loading    = 'lazy';
    img.style.left   = x + 'px';
    img.style.top    = '0px';
    img.style.width  = size + 'px';
    img.style.height = size + 'px';
    if (name) {
      img.dataset.modalName     = name;
      img.dataset.modalPackdesc = packDesc || '';
      img.dataset.modalUrl      = url || '';
    }
    return img;
  }

  /* ---- All known COB variant IDs — used to zero the cart before re-adding ---- */
  function getAllCobVariantIds() {
    var ids = {};
    function collect(p) {
      if (p && p.id)                       ids[p.id]              = 0;
      if (p && p.carton && p.carton.id)    ids[p.carton.id]       = 0;
    }
    collect(PRODS.baby.allseasons);
    collect(PRODS.baby.christmas);
    PRODS.junior.allseasons.forEach(collect);
    collect(PRODS.junior.christmas);
    PRODS.senior.allseasons.forEach(collect);
    if (PRODS.grad.single.id > 0) ids[PRODS.grad.single.id] = 0;
    if (PRODS.grad.pack.id > 0) ids[PRODS.grad.pack.id] = 0;
    if (PRODS.grad.pack.carton && PRODS.grad.pack.carton.id > 0) ids[PRODS.grad.pack.carton.id] = 0;
    if (PRODS.xmas_pic_wrapped.id > 0) ids[PRODS.xmas_pic_wrapped.id] = 0;
    if (PRODS.xmas_pic_wrapped.carton && PRODS.xmas_pic_wrapped.carton.id > 0) ids[PRODS.xmas_pic_wrapped.carton.id] = 0;
    return ids;
  }

  /* ---- Add / Update cart ---- */
  elSubmit.addEventListener('click', function () {
    /* If items were just added, this click goes to cart */
    if (elSubmit.dataset.cobGoCart) {
      window.location.href = '/cart';
      return;
    }
    var items = calcItems();
    if (items.length === 0) return;

    elSubmit.disabled = true;
    elSubmit.textContent = 'Updating...';
    delete elSubmit.dataset.cobGoCart;
    var errEl = document.getElementById('cob-cart-error');
    if (errEl) errEl.hidden = true;
    var discountEl = document.getElementById('cob-discount-applied');
    if (discountEl) discountEl.hidden = true;

    /* Merge items with same variant ID (e.g. Christmas split across age groups) */
    var merged = {}, order = [];
    items.forEach(function (item) {
      if (merged[item.id]) { merged[item.id].quantity += item.qty; }
      else { merged[item.id] = { id: item.id, quantity: item.qty }; order.push(item.id); }
    });
    var toAdd = order.map(function (id) { return merged[id]; })
                    .filter(function (item) { return item && item.id > 0 && item.quantity > 0; });

    if (toAdd.length === 0) {
      elSubmit.disabled = false;
      elSubmit.textContent = sessionStorage.getItem(COB_ADDED_KEY) ? 'Update cart' : 'Add to cart';
      return;
    }

    /* Zero all COB variants first so pressing the button again never duplicates. */
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: getAllCobVariantIds() })
    })
    .then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: toAdd })
      });
    })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          throw new Error(err.description || err.message || 'Cart error (' + res.status + ')');
        });
      }
      return res.json();
    })
    .then(function () {
      sessionStorage.setItem(COB_ADDED_KEY, '1');
      elClearCart.hidden = false;
      if (elProgressClear) elProgressClear.hidden = false;
      /* Check for auto-applied discounts before redirecting */
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      var discountEl  = document.getElementById('cob-discount-applied');
      var discountTxt = document.getElementById('cob-discount-text');
      var discount    = cart && cart.total_discount ? cart.total_discount : 0;

      if (discount > 0 && cart.items) {
        /* Build map: variantId → { original, final } line prices in cents */
        var lineMap = {};
        cart.items.forEach(function (ci) {
          lineMap[ci.variant_id] = {
            orig:  ci.original_line_price,
            final: ci.final_line_price
          };
        });

        /* Check if discount is per-line or order-level */
        var hasLineDiscounts = cart.items.some(function (ci) {
          return ci.final_line_price < ci.original_line_price;
        });

        var summaryEl = document.getElementById('cob-summary-items');
        if (summaryEl) {
          /* Remove any previous savings row */
          var prevSavings = summaryEl.querySelector('.cob__summary-savings');
          if (prevSavings) prevSavings.remove();

          if (hasLineDiscounts) {
            /* Per-line: update each row that has a saving */
            summaryEl.querySelectorAll('.cob__summary-line[data-variant-id]').forEach(function (row) {
              var vid = parseInt(row.dataset.variantId);
              var li  = lineMap[vid];
              if (li && li.final < li.orig) {
                var priceEl = row.querySelector('.cob__summary-line-price');
                if (priceEl) {
                  priceEl.innerHTML =
                    '<s class="cob__summary-orig-price">' + fmt(li.orig / 100) + '</s> ' +
                    fmt(li.final / 100);
                }
              }
            });
          } else {
            /* Order-level: show total savings row at the bottom */
            var savingsRow = document.createElement('div');
            savingsRow.className = 'cob__summary-savings';
            savingsRow.innerHTML =
              '<span class="cob__summary-line-name cob__summary-savings-label">Discount savings</span>' +
              '<span class="cob__summary-savings-amount">−' + fmt(discount / 100) + '</span>';
            summaryEl.appendChild(savingsRow);
          }
        }

        /* Update total and show banner */
        if (discountEl && discountTxt) {
          discountTxt.textContent = 'Discount applied: −' + fmt(discount / 100) + ' saved';
          discountEl.hidden = false;
        }
        elTotalPrice.textContent = fmt(cart.total_price / 100);
        var totalsLbl = document.getElementById('cob-totals-label');
        if (totalsLbl) totalsLbl.textContent = 'Your total';
      }

      elSubmit.disabled = false;
      elSubmit.textContent = 'Go to cart →';
      elSubmit.dataset.cobGoCart = '1';
    })
    .catch(function (err) {
      elSubmit.disabled = false;
      elSubmit.textContent = sessionStorage.getItem(COB_ADDED_KEY) ? 'Update cart' : 'Add to cart';
      var msg = (err && err.message) ? err.message : 'Something went wrong. Please try again.';
      /* Show Shopify error inline rather than letting it fail silently */
      var errEl = document.getElementById('cob-cart-error');
      if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
    });
  });

  /* ---- Helpers ---- */
  function sum(arr) {
    return arr.reduce(function (a, b) { return a + b; }, 0);
  }
  function fmt(n) {
    return '$' + n.toFixed(2);
  }
  function stat(label, val) {
    return '<div class="cob__stat"><span class="cob__stat-label">' + label + '</span><span class="cob__stat-val">' + val + '</span></div>';
  }

  /* Returns true only when price mode produces a lower total cost than variety */
  function modesDiffer() {
    var saved = state.opt;
    state.opt = 'variety';
    var vCost = calcItems().reduce(function (s, i) { return s + i.qty * i.price; }, 0);
    state.opt = 'price';
    var pCost = calcItems().reduce(function (s, i) { return s + i.qty * i.price; }, 0);
    state.opt = saved;
    return pCost < vCost;
  }

  /* Returns whichever of two products has more stock; falls back to a if equal or unknown */
  function stockChoice(a, b) {
    var sA = PROD_STOCK[a.id] !== undefined ? PROD_STOCK[a.id] : Infinity;
    var sB = PROD_STOCK[b.id] !== undefined ? PROD_STOCK[b.id] : Infinity;
    return sA >= sB ? a : b;
  }

  /* ---- Live price loading ---- */
  function loadLivePrices(callback) {
    var ids = [];
    function collect(p) {
      if (p.id && ids.indexOf(p.id) === -1)                    ids.push(p.id);
      if (p.carton && p.carton.id && ids.indexOf(p.carton.id) === -1) ids.push(p.carton.id);
    }
    collect(PRODS.baby.allseasons);
    collect(PRODS.baby.christmas);
    PRODS.junior.allseasons.forEach(collect);
    collect(PRODS.junior.christmas);
    PRODS.senior.allseasons.forEach(collect);
    if (PRODS.grad.single.id && ids.indexOf(PRODS.grad.single.id) === -1) ids.push(PRODS.grad.single.id);
    if (PRODS.grad.pack.id && ids.indexOf(PRODS.grad.pack.id) === -1) ids.push(PRODS.grad.pack.id);
    if (PRODS.grad.pack.carton.id && ids.indexOf(PRODS.grad.pack.carton.id) === -1) ids.push(PRODS.grad.pack.carton.id);
    if (PRODS.xmas_pic_wrapped.id && ids.indexOf(PRODS.xmas_pic_wrapped.id) === -1) ids.push(PRODS.xmas_pic_wrapped.id);
    if (PRODS.xmas_pic_wrapped.carton.id && ids.indexOf(PRODS.xmas_pic_wrapped.carton.id) === -1) ids.push(PRODS.xmas_pic_wrapped.carton.id);

    Promise.all(ids.filter(Boolean).map(function (id) {
      return fetch('/variants/' + id + '.js')
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    })).then(function (results) {
      var prices = {};
      results.forEach(function (v) {
        if (v) {
          prices[v.id] = v.price / 100;
          if (v.inventory_quantity !== undefined) PROD_STOCK[v.id] = v.inventory_quantity;
        }
      });
      callback(prices);
    });
  }

  function applyLivePrices(prices) {
    function upd(p) {
      if (prices[p.id] !== undefined)                    p.price = prices[p.id];
      if (p.carton && prices[p.carton.id] !== undefined) p.carton.price = prices[p.carton.id];
    }
    upd(PRODS.baby.allseasons);
    upd(PRODS.baby.christmas);
    PRODS.junior.allseasons.forEach(upd);
    upd(PRODS.junior.christmas);
    PRODS.senior.allseasons.forEach(upd);
    if (prices[PRODS.grad.single.id] !== undefined) PRODS.grad.single.price = prices[PRODS.grad.single.id];
    if (prices[PRODS.grad.pack.id] !== undefined) PRODS.grad.pack.price = prices[PRODS.grad.pack.id];
    if (prices[PRODS.grad.pack.carton.id] !== undefined) PRODS.grad.pack.carton.price = prices[PRODS.grad.pack.carton.id];
    if (prices[PRODS.xmas_pic_wrapped.id] !== undefined) PRODS.xmas_pic_wrapped.price = prices[PRODS.xmas_pic_wrapped.id];
    if (PRODS.xmas_pic_wrapped.carton && prices[PRODS.xmas_pic_wrapped.carton.id] !== undefined) PRODS.xmas_pic_wrapped.carton.price = prices[PRODS.xmas_pic_wrapped.carton.id];
  }

  /* ---- Product modal ---- */
  (function () {
    var modal    = document.getElementById('cob-product-modal');
    var mImg     = document.getElementById('cob-modal-img');
    var mName    = document.getElementById('cob-modal-name');
    var mDesc    = document.getElementById('cob-modal-desc');
    var mLink    = document.getElementById('cob-modal-link');
    var mClose   = document.getElementById('cob-modal-close');
    var backdrop = modal ? modal.querySelector('.cob__modal-backdrop') : null;
    if (!modal) return;

    function openModal(src, name, packDesc, url) {
      mImg.src            = src;
      mImg.alt            = name;
      mName.textContent   = name;
      mDesc.textContent   = packDesc;
      mLink.href          = url || '#';
      mLink.style.display = url ? '' : 'none';
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      mClose.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    mClose.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    section.addEventListener('click', function (e) {
      var thumb = e.target;
      if (!thumb.classList.contains('cob__vis-thumb') || !thumb.dataset.modalName) return;
      openModal(thumb.src, thumb.dataset.modalName, thumb.dataset.modalPackdesc || '', thumb.dataset.modalUrl || '');
    });
  }());

  /* ---- Info modal ---- */
  (function () {
    var modal    = document.getElementById('cob-info-modal');
    var mTitle   = document.getElementById('cob-info-modal-title');
    var mBody    = document.getElementById('cob-info-modal-body');
    var mClose   = document.getElementById('cob-info-modal-close');
    var backdrop = document.getElementById('cob-info-backdrop');
    if (!modal) return;

    function openInfoModal(opts) {
      mTitle.textContent = opts.title || '';
      var html = '';
      if (opts.img2) {
        html += '<div class="cob__info-imgs">';
        html += '<div class="cob__info-img-col">';
        if (opts.img) html += '<img src="' + opts.img + '" alt="' + (opts.imgLabel || '') + '" class="cob__info-img" loading="lazy">';
        if (opts.imgLabel) html += '<p class="cob__info-img-label">' + opts.imgLabel + '</p>';
        html += '</div><div class="cob__info-img-col">';
        html += '<img src="' + opts.img2 + '" alt="' + (opts.img2Label || '') + '" class="cob__info-img" loading="lazy">';
        if (opts.img2Label) html += '<p class="cob__info-img-label">' + opts.img2Label + '</p>';
        html += '</div></div>';
      } else if (opts.img) {
        html += '<div class="cob__info-img-wrap"><img src="' + opts.img + '" alt="' + (opts.imgLabel || opts.title || '') + '" class="cob__info-img cob__info-img--single" loading="lazy"></div>';
      }
      if (opts.spec) html += '<p class="cob__info-spec">' + opts.spec + '</p>';
      if (opts.desc) html += '<p class="cob__info-desc">' + opts.desc + '</p>';
      if (opts.pricing === 'grad') {
        var gp = PRODS.grad.pack;
        var gc = PRODS.grad.pack.carton;
        html += '<table class="cob__info-pricing">';
        html += '<thead><tr><th>Format</th><th>Price</th><th>Per book</th></tr></thead><tbody>';
        if (gp.id && gp.price > 0) {
          html += '<tr><td>10-pack</td><td>' + fmt(gp.price) + '</td><td>' + fmt(gp.price / 10) + '</td></tr>';
        }
        if (gc.id && gc.price > 0) {
          html += '<tr><td>80-book carton</td><td>' + fmt(gc.price) + '</td><td>' + fmt(gc.price / 80) + '</td></tr>';
        }
        html += '</tbody></table>';
      } else if (opts.pricing === 'baby') {
        var ba = PRODS.baby.allseasons;
        var bc = PRODS.baby.christmas;
        html += '<table class="cob__info-pricing">';
        html += '<thead><tr><th>Format</th><th>Price</th><th>Per book</th></tr></thead><tbody>';
        if (ba.id && ba.price > 0) {
          html += '<tr><td>All-Seasons ' + ba.size + '-pack</td><td>' + fmt(ba.price) + '</td><td>' + fmt(ba.price / ba.size) + '</td></tr>';
        }
        if (ba.carton && ba.carton.id && ba.carton.price > 0) {
          html += '<tr><td>All-Seasons carton (' + ba.carton.size + ' books)</td><td>' + fmt(ba.carton.price) + '</td><td>' + fmt(ba.carton.price / ba.carton.size) + '</td></tr>';
        }
        if (bc.id && bc.price > 0) {
          html += '<tr><td>Christmas ' + bc.size + '-pack</td><td>' + fmt(bc.price) + '</td><td>' + fmt(bc.price / bc.size) + '</td></tr>';
        }
        if (bc.carton && bc.carton.id && bc.carton.price > 0) {
          html += '<tr><td>Christmas carton (' + bc.carton.size + ' books)</td><td>' + fmt(bc.carton.price) + '</td><td>' + fmt(bc.carton.price / bc.carton.size) + '</td></tr>';
        }
        html += '</tbody></table>';
      } else if (opts.pricing === 'xmas-wrapped') {
        var wp  = PRODS.xmas_pic_wrapped;
        var wc  = PRODS.xmas_pic_wrapped.carton;
        var up  = PRODS.junior.christmas; /* unwrapped 10-pack for comparison */
        html += '<table class="cob__info-pricing">';
        html += '<thead><tr><th>Format</th><th>Price</th><th>Per book</th></tr></thead><tbody>';
        if (wp.id && wp.price > 0) {
          html += '<tr><td>Pre-wrapped ' + wp.size + '-pack</td><td>' + fmt(wp.price) + '</td><td>' + fmt(wp.price / wp.size) + '</td></tr>';
        }
        if (wc && wc.id && wc.price > 0) {
          html += '<tr><td>Pre-wrapped carton (' + wc.size + ' books)</td><td>' + fmt(wc.price) + '</td><td>' + fmt(wc.price / wc.size) + '</td></tr>';
        }
        if (up && up.id && up.price > 0) {
          html += '<tr><td>Unwrapped ' + up.size + '-pack</td><td>' + fmt(up.price) + '</td><td>' + fmt(up.price / up.size) + '</td></tr>';
        }

        html += '</tbody></table>';
      } else if (opts.pricing === 'junior' || opts.pricing === 'senior') {
        var pa = opts.pricing === 'junior' ? PRODS.junior.allseasons : PRODS.senior.allseasons;
        var pc = opts.pricing === 'junior' ? PRODS.junior.christmas : PRODS.senior.christmas;
        var paFirst = pa[0]; /* all allseasons options share the same price */
        html += '<table class="cob__info-pricing">';
        html += '<thead><tr><th>Format</th><th>Price</th><th>Per book</th></tr></thead><tbody>';
        if (paFirst && paFirst.id && paFirst.price > 0) {
          html += '<tr><td>All-Seasons ' + paFirst.size + '-pack</td><td>' + fmt(paFirst.price) + '</td><td>' + fmt(paFirst.price / paFirst.size) + '</td></tr>';
        }
        if (paFirst && paFirst.carton && paFirst.carton.id && paFirst.carton.price > 0) {
          html += '<tr><td>All-Seasons carton (' + paFirst.carton.size + ' books)</td><td>' + fmt(paFirst.carton.price) + '</td><td>' + fmt(paFirst.carton.price / paFirst.carton.size) + '</td></tr>';
        }
        if (pc && pc.id && pc.price > 0) {
          html += '<tr><td>Christmas ' + pc.size + '-pack</td><td>' + fmt(pc.price) + '</td><td>' + fmt(pc.price / pc.size) + '</td></tr>';
        }
        if (pc && pc.carton && pc.carton.id && pc.carton.price > 0) {
          html += '<tr><td>Christmas carton (' + pc.carton.size + ' books)</td><td>' + fmt(pc.carton.price) + '</td><td>' + fmt(pc.carton.price / pc.carton.size) + '</td></tr>';
        }
        html += '</tbody></table>';
      } else if (opts.pricing === 'theme') {
        var themeRows = [
          ['100% Christmas',    '100%', '0%'],
          ['Mostly Christmas',   '75%', '25%'],
          ['Half & Half',        '50%', '50%'],
          ['Mostly All-Seasons', '25%', '75%'],
          ['100% All-Seasons',    '0%', '100%']
        ];
        html += '<table class="cob__info-pricing cob__info-pricing--theme">';
        html += '<thead><tr><th>Mix</th><th>Christmas</th><th>All-Seasons</th></tr></thead><tbody>';
        themeRows.forEach(function(r) {
          html += '<tr><td>' + r[0] + '</td><td>' + r[1] + '</td><td>' + r[2] + '</td></tr>';
        });
        html += '</tbody></table>';
      }
      mBody.innerHTML = html;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      mClose.focus();
    }

    function closeInfoModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    mClose.addEventListener('click', closeInfoModal);
    if (backdrop) backdrop.addEventListener('click', closeInfoModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeInfoModal();
    });

    section.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.cob__info-btn') : null;
      if (!btn) return;
      var d = btn.dataset;
      if (!d.infoImg && !d.infoImg2 && !d.infoSpec && !d.infoDesc && !d.infoPricing) return;
      openInfoModal({
        title:     d.infoTitle     || '',
        img:       d.infoImg       || '',
        imgLabel:  d.infoImgLabel  || '',
        img2:      d.infoImg2      || '',
        img2Label: d.infoImg2Label || '',
        spec:      d.infoSpec      || '',
        desc:      d.infoDesc      || '',
        pricing:   d.infoPricing   || ''
      });
    });
  }());

  /* ---- Clear confirm modal ---- */
  function openClearModal() {
    elClearModal.hidden = false;
    document.body.style.overflow = 'hidden';
    document.getElementById('cob-clear-cancel').focus();
  }

  function closeClearModal() {
    elClearModal.hidden = true;
    document.body.style.overflow = '';
  }

  function clearAll() {
    /* Reset state */
    themeInteracted = false;
    elThemeRange.classList.add('cob__theme-range--dormant');
    state.rooms    = { baby: 0, junior: 0, senior: 0 };
    state.children = { baby: [], junior: [], senior: [] };
    state.theme    = 0;
    state.opt      = 'variety';
    state.grad     = { enabled: false, chosen: false, count: 0, mode: 'add' };
    state.wrapped       = false;
    state.wrappedChosen = false;

    /* Reset wrapped toggle */
    section.querySelectorAll('[data-wrapped-yn]').forEach(function (b) { b.classList.remove('is-active'); });

    /* Reset grad inputs */
    var gradDetailElC = document.getElementById('cob-grad-detail');
    var gradCountElC  = document.getElementById('cob-grad-count');
    section.querySelectorAll('[data-grad-yn]').forEach(function (b) {
      b.classList.remove('is-active');
    });
    if (gradDetailElC) gradDetailElC.hidden = true;
    state.grad.count = 0;
    if (gradCountElC)  gradCountElC.value   = 0;
    section.querySelectorAll('input[name="cob-grad-mode"]').forEach(function (r) {
      r.checked = (r.value === 'add');
    });

    /* Clear persisted state */
    calculated = false;
    try { localStorage.removeItem(COB_STATE_KEY); } catch(e) {}
    try { sessionStorage.removeItem(COB_CALC_KEY); } catch(e) {}
    sessionStorage.removeItem(COB_ADDED_KEY);

    /* Hide results and wipe visual rows */
    if (elResults)  elResults.hidden  = true;
    if (elCalcWrap) elCalcWrap.hidden = true;
    var visRows = document.getElementById('cob-vis-rows');
    if (visRows) { while (visRows.firstChild) visRows.removeChild(visRows.firstChild); }

    /* Wipe summary */
    if (elSummaryItems)  elSummaryItems.innerHTML = '<p class="cob__summary-empty">Add your rooms above to see your recommended order.</p>';
    if (elSummaryFooter) elSummaryFooter.hidden = true;
    if (elOrderTotals)   elOrderTotals.hidden = true;
    if (elTotalPrice)    elTotalPrice.textContent = '';

    /* Clear Shopify cart (fire and forget — UI resets regardless) */
    fetch('/cart/clear.js', { method: 'POST' }).catch(function () {});

    closeClearModal();

    /* Reset stepper displays */
    section.querySelectorAll('.cob__room-row').forEach(function (row) {
      var valEl = row.querySelector('.cob__stepper-val');
      if (valEl) valEl.textContent = '0';
    });

    /* Reset optimisation toggle */
    section.querySelectorAll('.cob__opt-btn').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.opt === 'variety');
    });

    /* Reset theme slider */
    elThemeRange.value = 0;
    updateThemeUi();

    /* Reset submit button to original label */
    delete elSubmit.dataset.cobGoCart;
    elSubmit.disabled = false;
    elSubmit.textContent = 'Add to cart';

    /* Hide clear button */
    elClearCart.hidden = true;
    if (elProgressClear) elProgressClear.hidden = true;

    /* Re-render */
    renderChildren();
    update();
  }

  /* Wire clear modal */
  elClearCart.addEventListener('click', openClearModal);
  if (elProgressClear) elProgressClear.addEventListener('click', openClearModal);

  document.getElementById('cob-clear-cancel').addEventListener('click', closeClearModal);
  document.getElementById('cob-clear-modal-close').addEventListener('click', closeClearModal);
  document.getElementById('cob-clear-backdrop').addEventListener('click', closeClearModal);
  document.getElementById('cob-clear-confirm').addEventListener('click', clearAll);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !elClearModal.hidden) closeClearModal();
  });

  /* ---- Progress step click: scroll to that step ---- */
  (function () {
    var STEP_ELS = {
      1: document.getElementById('cob-step-rooms'),
      2: elStepChildren,
      3: elStepTheme,
      4: elStepGrad
    };
    var elProg = document.getElementById('cob-progress');
    section.querySelectorAll('.cob__progress-step').forEach(function (stepEl) {
      stepEl.addEventListener('click', function () {
        var step = parseInt(stepEl.dataset.step);
        var target = STEP_ELS[step];
        if (!target || target.hidden) return;
        var progressHeight = elProg ? elProg.offsetHeight : 0;
        var top = target.getBoundingClientRect().top + window.scrollY - progressHeight - 8;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }());

  /* Sticky progress bar shadow when scrolled past its natural position */
  var elProgress = document.getElementById('cob-progress');
  if (elProgress) {
    var progressObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          elProgress.style.boxShadow = entry.intersectionRatio < 1
            ? '0 3px 12px rgba(0,0,0,0.10)'
            : '0 2px 8px rgba(0,0,0,0)';
        });
      },
      { threshold: [1], rootMargin: '-1px 0px 0px 0px' }
    );
    progressObserver.observe(elProgress);
  }

  /* Reset button state when page is restored from browser back-forward cache */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      var prevAdded = !!sessionStorage.getItem(COB_ADDED_KEY);
      elSubmit.disabled = false;
      elSubmit.textContent = prevAdded ? 'Update cart' : 'Add to cart';
      var hasAnything = AGE_GROUPS.some(function (ag) { return state.rooms[ag] > 0; }) ||
        AGE_GROUPS.some(function (ag) { return sum(state.children[ag]) > 0; }) ||
        prevAdded;
      elClearCart.hidden = !hasAnything;
      if (elProgressClear) elProgressClear.hidden = !hasAnything;
    }
  });

  /* Init — restore saved state first, then fetch prices and render */
  restoreState();
  syncRestoredUi();
  loadLivePrices(function (prices) {
    applyLivePrices(prices);
    updateThemeUi();
    renderChildren();
    update();
  });

  /* ---- Order note: render **bold** and line breaks ---- */
  (function () {
    var noteEl = document.getElementById('cob-order-note');
    if (!noteEl || !noteEl.dataset.raw) return;
    var raw = noteEl.dataset.raw
      .replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#39;/g, "'").replace(/&quot;/g, '"');
    noteEl.innerHTML = raw.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  }());
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grad-packs-landing"] && !Shopify.designMode) return;
  try {
    
(function() {
  var widget = document.querySelector('.gp-calc__columns');
  if (!widget) return;
  var slider = document.getElementById('gp-slider');
  var countEl = document.getElementById('gp-child-count');
  var summaryEl = document.getElementById('gp-summary');
  var noteEl = document.getElementById('gp-discount-note');
  var btn = document.getElementById('gp-add-to-cart');

  var v10 = widget.dataset.v10;
  var v80 = widget.dataset.v80 || null;
  var price10 = parseInt(widget.dataset.price10) / 100;
  var price80 = widget.dataset.price80 ? parseInt(widget.dataset.price80) / 100 : null;
  var img10 = widget.dataset.img10 || null;
  var img80 = widget.dataset.img80 || null;
  var name10 = widget.dataset.name10 || '';
  var name80 = widget.dataset.name80 || '';
  var url10 = widget.dataset.url10 || '';
  var url80 = widget.dataset.url80 || '';
  var modalImg10 = widget.dataset.modalimg10 || null;
  var modalImg80 = widget.dataset.modalimg80 || null;
  var CARTON_PACKS = 8;
  var perBook10 = price10 / 10;
  var perBook80 = price80 !== null ? price80 / 80 : null;

  function formatMoney(n) {
    return '$' + n.toFixed(2).replace(/\.00$/, '');
  }


  function calcOrder(num10) {
    if (!v80) return { cartons: 0, loose: num10 };
    var cartons = 0, loose = num10;
    while (loose >= CARTON_PACKS) {
      cartons++;
      loose -= CARTON_PACKS;
    }
    return { cartons: cartons, loose: loose };
  }

  function renderVisual(order) {
    var el = document.getElementById('gp-visual');
    if (!el) return;
    while (el.firstChild) el.removeChild(el.firstChild);

    var isMobile = window.innerWidth <= 768;
    var THUMB = isMobile ? 80 : 160;
    var STEP = THUMB / 2;

    function makeRow(brightQty, src, name, packDesc, url, modalSrc) {
      var total = Math.max(brightQty, 1);
      var row = document.createElement('div');
      row.className = 'gp-vis-row';
      row.style.height = THUMB + 'px';
      var x = 0;
      for (var i = 0; i < total; i++) {
        var img = document.createElement('img');
        img.className = 'gp-vis-thumb';
        img.src = src;
        img.alt = name || '';
        img.loading = 'lazy';
        img.style.left = x + 'px';
        img.style.top = '0';
        img.style.width = THUMB + 'px';
        img.style.height = THUMB + 'px';
        img.style.opacity = i < brightQty ? '1' : '0.2';
        if (name) {
          img.dataset.modalName     = name;
          img.dataset.modalPackdesc = packDesc || '';
          img.dataset.modalUrl      = url || '';
          img.dataset.modalSrc      = modalSrc || src;
        }
        row.appendChild(img);
        x += STEP;
      }
      row.style.width = (x - STEP + THUMB) + 'px';
      return row;
    }

    function makeLabelled(brightQty, src, label, name, packDesc, url, modalSrc) {
      var container = document.createElement('div');
      container.style.display = 'flex';
      container.style.flexDirection = 'column';
      container.style.alignItems = 'flex-start';
      container.style.gap = '6px';
      container.appendChild(makeRow(brightQty, src, name, packDesc, url, modalSrc));
      var lbl = document.createElement('div');
      lbl.style.color = 'var(--gp-text)';
      lbl.style.paddingTop = '6px';
      lbl.style.display = 'block';
      lbl.style.width = '100%';
      lbl.style.textAlign = 'left';
      lbl.textContent = label;
      container.appendChild(lbl);
      return container;
    }

    var wrap = document.createElement('div');
    wrap.style.display = 'flex';
    wrap.style.flexDirection = 'column';
    wrap.style.alignItems = 'flex-start';
    wrap.style.gap = '16px';
    if (img80) wrap.appendChild(makeLabelled(order.cartons, img80, 'Full carton (80 books): ' + formatMoney(perBook80) + '/book', name80, formatMoney(price80) + ' per carton \xb7 ' + formatMoney(perBook80) + ' per book', url80, modalImg80));
    if (img10) wrap.appendChild(makeLabelled(order.loose, img10, '10-pack: ' + formatMoney(perBook10) + '/book', name10, formatMoney(price10) + ' per pack \xb7 ' + formatMoney(perBook10) + ' per book', url10, modalImg10));
    el.style.height = 'auto';
    el.appendChild(wrap);
  }

  function update() {
    var children = Math.min(999, Math.max(0, parseInt(countEl.value) || 0));
    var num10 = Math.ceil(children / 10);
    var books = num10 * 10;
    var order = calcOrder(num10);

    if (children === 0) {
      summaryEl.innerHTML = '';
      noteEl.textContent = '';
      btn.disabled = true;
      var pct0 = 0;
      slider.style.background = 'linear-gradient(to right, var(--gp-warm) 0%, var(--gp-warm) ' + pct0 + '%, var(--gp-track) ' + pct0 + '%, var(--gp-track) 100%)';
      renderVisual(order);
      return;
    }

    btn.disabled = false;
    var total, discountNote = '';
    if (order.cartons > 0 && price80 !== null) {
      total = order.cartons * price80 + order.loose * price10;
    } else {
      total = num10 * price10;
    }

    var line1, line2, line3;
    var perBook = total / books;
    line2 = books + ' books';
    line3 = '<strong>' + formatMoney(total) + '</strong> &nbsp;&middot;&nbsp; ' + formatMoney(perBook) + '/book avg';
    if (order.cartons > 0) {
      var cartonBooks = order.cartons * 80;
      var cartonWord = order.cartons === 1 ? 'carton' : 'cartons';
      line1 = order.cartons + ' ' + cartonWord + ' (' + cartonBooks + ' books) &nbsp;&middot;&nbsp; ' + formatMoney(perBook80) + '/book';
      if (order.loose > 0) {
        line1 += '<br>' + order.loose + ' &times; 10-pack &nbsp;&middot;&nbsp; ' + formatMoney(perBook10) + '/book';
      }
    } else {
      var packLabel = num10 === 1 ? '10-pack' : '10-packs';
      line1 = num10 + ' &times; ' + packLabel + ' &nbsp;&middot;&nbsp; ' + formatMoney(perBook10) + '/book';
    }
    summaryEl.innerHTML = line1 + '<br>' + line2 + '<br>' + line3;
    noteEl.textContent = discountNote;

    var pct = (Math.min(children, 400) / 400) * 100;
    slider.style.background = 'linear-gradient(to right, var(--gp-warm) 0%, var(--gp-warm) ' + pct + '%, var(--gp-track) ' + pct + '%, var(--gp-track) 100%)';

    btn.dataset.order = JSON.stringify(order);
    renderVisual(order);
  }

  slider.addEventListener('input', function() {
    countEl.value = slider.value;
    update();
  });

  countEl.addEventListener('focus', function() {
    countEl.select();
  });

  countEl.addEventListener('input', function() {
    slider.value = Math.min(400, parseInt(countEl.value) || 0);
    update();
  });

  countEl.addEventListener('blur', function() {
    var val = Math.min(999, Math.max(0, parseInt(countEl.value) || 0));
    countEl.value = val;
    slider.value = Math.min(400, val);
    update();
  });

  update();

  btn.addEventListener('click', function() {
    var order = JSON.parse(btn.dataset.order || '{"cartons":0,"loose":0}');
    var items = [];
    if (order.cartons > 0 && v80) items.push({ id: parseInt(v80), quantity: order.cartons });
    if (order.loose > 0) items.push({ id: parseInt(v10), quantity: order.loose });
    if (items.length === 0) return;

    btn.textContent = 'Adding…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function() {
      window.location.href = '/cart';
    }).catch(function() {
      btn.textContent = 'Add to cart';
      btn.disabled = false;
    });
  });

  /* ---- Product modal ---- */
  (function () {
    var modal    = document.getElementById('gp-product-modal');
    var mImg     = document.getElementById('gp-modal-img');
    var mName    = document.getElementById('gp-modal-name');
    var mDesc    = document.getElementById('gp-modal-desc');
    var mLink    = document.getElementById('gp-modal-link');
    var mClose   = document.getElementById('gp-modal-close');
    var backdrop = modal ? modal.querySelector('.gp__modal-backdrop') : null;
    if (!modal) return;

    function openModal(src, name, packDesc, url) {
      mImg.src            = src;
      mImg.alt            = name;
      mName.textContent   = name;
      mDesc.textContent   = packDesc;
      mLink.href          = url || '#';
      mLink.style.display = url ? '' : 'none';
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      mClose.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    mClose.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    document.addEventListener('click', function (e) {
      var thumb = e.target;
      if (!thumb.classList.contains('gp-vis-thumb') || !thumb.dataset.modalName) return;
      openModal(thumb.dataset.modalSrc || thumb.src, thumb.dataset.modalName, thumb.dataset.modalPackdesc || '', thumb.dataset.modalUrl || '');
    });
  }());

})();

document.querySelectorAll('.gp-carousel').forEach(function(carousel) {
  const slides = carousel.querySelectorAll('.gp-carousel__slide');
  const prev = carousel.querySelector('.gp-carousel__prev');
  const next = carousel.querySelector('.gp-carousel__next');
  const dots = carousel.querySelectorAll('.gp-carousel__dot');
  if (slides.length < 2) return;
  let current = 0;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    if (dots[current]) dots[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    if (dots[current]) dots[current].classList.add('is-active');
  }

  if (prev) prev.addEventListener('click', function() { goTo(current - 1); });
  if (next) next.addEventListener('click', function() { goTo(current + 1); });
  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { goTo(i); });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-by-age"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.oba-calc').forEach(function(calc) {
    var ranges = calc.querySelectorAll('.oba-range');
    var nums = calc.querySelectorAll('.oba-slider-num');
    var summary = calc.querySelector('.oba-summary');
    var btn = calc.querySelector('.oba-btn');

    var variantIds = calc.dataset.variantIds.split(',');
    var maxVal = parseInt(calc.dataset.max) || 500;

    var tiers = [
      { min: 1,   price: parseFloat(calc.dataset.t1Price) },
      { min: parseInt(calc.dataset.t2Min), price: parseFloat(calc.dataset.t2Price) },
      { min: parseInt(calc.dataset.t3Min), price: parseFloat(calc.dataset.t3Price) },
      { min: parseInt(calc.dataset.t4Min), price: parseFloat(calc.dataset.t4Price) },
      { min: parseInt(calc.dataset.t5Min), price: parseFloat(calc.dataset.t5Price) }
    ];

    function getPrice(total) {
      var price = tiers[0].price;
      for (var i = 1; i < tiers.length; i++) {
        if (total >= tiers[i].min) price = tiers[i].price;
      }
      return price;
    }

    function fmt(n) {
      return '$' + n.toFixed(2);
    }

    function updateFill(input) {
      var pct = (parseInt(input.value) / maxVal) * 100;
      input.style.background = 'linear-gradient(to right, var(--oba-accent) 0%, var(--oba-accent) ' + pct + '%, #e5ddd8 ' + pct + '%, #e5ddd8 100%)';
    }

    function update() {
      var total = 0;
      ranges.forEach(function(r, i) {
        var q = parseInt(r.value);
        nums[i].value = q;
        total += q;
        updateFill(r);
      });

      if (total === 0) {
        summary.textContent = '';
        btn.disabled = true;
        return;
      }

      var pricePerBook = getPrice(total);
      var basePrice = tiers[0].price;
      var totalCost = total * pricePerBook;
      var saving = (basePrice - pricePerBook) * total;

      var bookWord = total === 1 ? '1 book' : total + ' books';
      var text = bookWord + ' at ' + fmt(pricePerBook) + '/book = ' + fmt(totalCost);
      if (saving > 0.001) {
        text += ' (saving ' + fmt(saving) + ')';
      }
      summary.textContent = text;
      btn.disabled = false;
    }

    ranges.forEach(function(r) {
      r.addEventListener('input', update);
    });

    nums.forEach(function(num, i) {
      num.addEventListener('input', function() {
        var val = parseInt(num.value) || 0;
        if (val < 0) val = 0;
        if (val > maxVal) val = maxVal;
        ranges[i].value = val;
        update();
      });
      num.addEventListener('blur', function() {
        var val = parseInt(num.value) || 0;
        if (val < 0) val = 0;
        if (val > maxVal) val = maxVal;
        num.value = val;
        ranges[i].value = val;
        update();
      });
    });

    btn.addEventListener('click', function() {
      var total = 0;
      ranges.forEach(function(r) { total += parseInt(r.value); });
      if (total === 0) return;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      var items = [];
      ranges.forEach(function(r, i) {
        var q = parseInt(r.value);
        if (q > 0) items.push({ id: parseInt(variantIds[i]), quantity: q });
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        window.location.href = '/cart';
      })
      .catch(function() {
        btn.disabled = false;
        btn.textContent = 'Add to cart';
      });
    });

    update();
  });

  document.querySelectorAll('.oba-carousel').forEach(function(carousel) {
    var track = carousel.querySelector('.oba-carousel__track');
    var slides = carousel.querySelectorAll('.oba-carousel__slide');
    var prevBtn = carousel.querySelector('.oba-carousel__btn--prev');
    var nextBtn = carousel.querySelector('.oba-carousel__btn--next');
    var dotsWrap = carousel.querySelector('.oba-carousel__dots');
    if (!track || slides.length < 2) return;

    var current = 0;
    var dots = [];

    if (dotsWrap) {
      slides.forEach(function(_, i) {
        var dot = document.createElement('button');
        dot.className = 'oba-carousel__dot' + (i === 0 ? ' oba-carousel__dot--active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.addEventListener('click', function() { goTo(i); });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function goTo(idx) {
      current = (idx + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function(d, i) {
        d.classList.toggle('oba-carousel__dot--active', i === current);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    var trackWrap = carousel.querySelector('.oba-carousel__track-wrap');
    if (trackWrap) {
      trackWrap.addEventListener('click', function(e) {
        if (e.target.closest('.oba-carousel__btn')) return;
        goTo(current + 1);
      });
    }

    var touchStartX = 0;
    track.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
    }, { passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-by-format"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.obf-calc').forEach(function(calc) {
    var ranges = calc.querySelectorAll('.obf-range');
    var nums = calc.querySelectorAll('.obf-slider-num');
    var summary = calc.querySelector('.obf-summary');
    var btn = calc.querySelector('.obf-btn');
    var variantIds = calc.dataset.variantIds.split(',');
    var variantPrices = calc.dataset.variantPrices.split(',').map(function(p) { return parseInt(p); });
    var maxVal = parseInt(calc.dataset.max) || 500;

    var discountTiers = [
      { min: parseInt(calc.dataset.t1Min), pct: parseFloat(calc.dataset.t1Discount) },
      { min: parseInt(calc.dataset.t2Min), pct: parseFloat(calc.dataset.t2Discount) },
      { min: parseInt(calc.dataset.t3Min), pct: parseFloat(calc.dataset.t3Discount) }
    ];

    function getDiscount(total) {
      var pct = 0;
      discountTiers.forEach(function(t) {
        if (total >= t.min) pct = t.pct;
      });
      return pct;
    }

    function fmt(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateFill(input) {
      var pct = (parseInt(input.value) / maxVal) * 100;
      input.style.background = 'linear-gradient(to right, var(--obf-accent) 0%, var(--obf-accent) ' + pct + '%, #e5ddd8 ' + pct + '%, #e5ddd8 100%)';
    }

    function update() {
      var total = 0;
      var undiscountedCents = 0;
      ranges.forEach(function(r, i) {
        var q = parseInt(r.value);
        nums[i].value = q;
        total += q;
        undiscountedCents += q * (variantPrices[i] || 0);
        updateFill(r);
      });

      if (total === 0) {
        summary.textContent = '';
        btn.disabled = true;
        return;
      }

      var discountPct = getDiscount(total);
      var discountedCents = Math.round(undiscountedCents * (1 - discountPct / 100));
      var savingCents = undiscountedCents - discountedCents;
      var perBookCents = Math.round(discountedCents / total);
      var bookWord = total === 1 ? '1 book' : total + ' books';
      var text = bookWord + ' = ' + fmt(discountedCents) + ' (' + fmt(perBookCents) + '/book';
      if (discountPct > 0) {
        text += ', saving ' + fmt(savingCents) + ' with ' + discountPct + '% off';
      }
      text += ')';
      summary.textContent = text;
      btn.disabled = false;
    }

    ranges.forEach(function(r) {
      r.addEventListener('input', update);
    });

    nums.forEach(function(num, i) {
      num.addEventListener('input', function() {
        var val = parseInt(num.value) || 0;
        if (val < 0) val = 0;
        if (val > maxVal) val = maxVal;
        ranges[i].value = val;
        update();
      });
      num.addEventListener('blur', function() {
        var val = parseInt(num.value) || 0;
        if (val < 0) val = 0;
        if (val > maxVal) val = maxVal;
        num.value = val;
        ranges[i].value = val;
        update();
      });
    });

    btn.addEventListener('click', function() {
      var total = 0;
      ranges.forEach(function(r) { total += parseInt(r.value); });
      if (total === 0) return;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      var items = [];
      ranges.forEach(function(r, i) {
        var q = parseInt(r.value);
        if (q > 0) items.push({ id: parseInt(variantIds[i]), quantity: q });
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        window.location.href = '/cart';
      })
      .catch(function() {
        btn.disabled = false;
        btn.textContent = 'Add to cart';
      });
    });

    update();
  });

  document.querySelectorAll('.obf-carousel').forEach(function(carousel) {
    var track = carousel.querySelector('.obf-carousel__track');
    var slides = carousel.querySelectorAll('.obf-carousel__slide');
    var prevBtn = carousel.querySelector('.obf-carousel__btn--prev');
    var nextBtn = carousel.querySelector('.obf-carousel__btn--next');
    var dotsWrap = carousel.querySelector('.obf-carousel__dots');
    if (!track || slides.length < 2) return;

    var current = 0;
    var dots = [];

    if (dotsWrap) {
      slides.forEach(function(_, i) {
        var dot = document.createElement('button');
        dot.className = 'obf-carousel__dot' + (i === 0 ? ' obf-carousel__dot--active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.addEventListener('click', function() { goTo(i); });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function goTo(idx) {
      current = (idx + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function(d, i) {
        d.classList.toggle('obf-carousel__dot--active', i === current);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    var touchStartX = 0;
    track.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
    }, { passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
